import { PlOption } from 'pl-core-services';

export const PL_MEDICAID_OPTIONS: PlOption[] = [
  { value: 'true', label: 'Yes' },
  { value: 'false', label: 'No' },
  { value: 'unknown', label: 'Unknown' },
];
